export default "__VITE_ASSET__DEWZK4Bp__"